import { Notification } from "element-ui";

export const asyncHandler = (promise) =>
  promise
    .then((resp) => resp.data)
    .catch((error) => {
      let message = "There was an error";
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {
        message = Object.values(error.response.data.errors)
          .flat()
          .join("<br/>");
      }
      Notification({
        title: "Error",
        message: message,
        dangerouslyUseHTMLString: true,
        type: "error",
      });
      return { success: false };
    });
